import React, {useEffect, useState} from "react";
import './AppSensorConfiguration.scss'
import ExternalModal from "../_common/ExternalModal";
import ErrorModal from "../_common/ErrorModal";

const AppSensorConfiguration = () => {
    const [link, setLink] = useState(null)
    const [sentModal, setSentModal] = useState(false)
    const [errorModal, setErrorModal] = useState(false)

    useEffect(() => {
       loadLink()
    },[])

    const toggleSentModal = () => {
        setSentModal(!sentModal)
    }

    const toggleErrorModal = () => {
        setErrorModal(!errorModal)
    }


    const loadLink = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const sensorId = urlParams.get('sensorId')
        const key = urlParams.get('key')
        fetch(`${process.env.REACT_APP_API_URL}/panel/sensor_ttn_link/${sensorId}`, {
            method: "GET",
            headers: {
                'Authorization': key
            }
        })
            .then(res => {
                if (res.status === 200) {
                    return res.text()
                }
            })
            .then((link) => {
                setLink(link)
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }

    const sendTimeRequest = (uploadTime) => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const sensorId = urlParams.get('sensorId')
        const key = urlParams.get('key')
        fetch(`${process.env.REACT_APP_API_URL}/panel/update_sensor_measurement_upload_time/${sensorId}/${uploadTime}`, {
            method: "POST",
            headers: {
                'Authorization': key
            }
        })
            .then(res => {
                if (res.status === 200) {
                   toggleSentModal()
                } else {
                    toggleErrorModal()
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }

  const updateSensorMode = () => {
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const sensorId = urlParams.get('sensorId')
        const key = urlParams.get('key')
        fetch(`${process.env.REACT_APP_API_URL}/panel/set_sensor_mode_count/${sensorId}`, {
            method: "POST",
            headers: {
                'Authorization': key
            }
        })
            .then(res => {
                if (res.status === 200) {
                   toggleSentModal()
                } else {
                    toggleErrorModal()
                }
            })
            .catch(err => {
                console.log('ERROR', err);
            })
    }


    return (
        <>
            <div className="container">
                <div className="sensorLink">
                   <a href={link} target='_blank'>{link}</a>
                </div>
                <div className="btnsContainer">
                    <h4> Set  measurements upload time</h4>
                    <button onClick={() => sendTimeRequest('1_MINUTE')} className="setTimeButton">
                            1 min
                    </button>
                    <button onClick={() => sendTimeRequest('5_MINUTES')} className="setTimeButton">
                            5 min
                    </button>
                    <button onClick={() => sendTimeRequest('20_MINUTES')} className="setTimeButton">
                            20 min
                    </button>
                </div>
                <div className="updateSensorContainer">
                    <h4>Update sensor mode</h4>
                    <button onClick={updateSensorMode} className="setTimeButton">
                        Update Sensor
                    </button>
                </div>
            </div>
            {sentModal && (
                <ExternalModal
                    closeMethod={toggleSentModal}
                    title={'Request sent'}
                />
            )}
            {errorModal && (
                <ErrorModal
                    closeMethod={toggleErrorModal}
                    error='Something went wrong'
                />
            )}
        </>
    )

}

export default AppSensorConfiguration
